import type { MapboxMap } from "@/layers/MapboxMap";

const PREFIX = "gl-draw";

export function getDrawLayers(map: MapboxMap) {
  const layers = map.getStyle().layers.filter((layer) => layer.id.startsWith(PREFIX));
  return layers.map((l) => l.id);
}
